import { render, staticRenderFns } from "./TabRisques.vue?vue&type=template&id=e8c0a186"
import script from "./TabRisques.vue?vue&type=script&lang=js"
export * from "./TabRisques.vue?vue&type=script&lang=js"
import style0 from "./TabRisques.vue?vue&type=style&index=0&id=e8c0a186&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports